import { render, staticRenderFns } from "./ShortcutTile.vue?vue&type=template&id=4e6d2732&scoped=true&"
import script from "./ShortcutTile.vue?vue&type=script&lang=js&"
export * from "./ShortcutTile.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutTile.vue?vue&type=style&index=0&id=4e6d2732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d2732",
  null
  
)

export default component.exports